import { Box } from 'grommet';
import { observer } from 'mobx-react-lite';
import { AddNewButton } from '../../AddNewButton';
import { useMemo, useState } from 'react';
import { CreateSessionEstimateModal } from '..';
import { SessionEstimatePanel } from './SessionEstimatePanel';
import { Estimate } from '@talon/web/lib/api';
import { useEstimateStore } from '@talon/web/src/context';
import { DateString } from '@talon/web/src/types';
import { byPosition } from '@talon/web/src/utils/stableOrder';
import { EmptyState } from '@talon/web/src/components/ui/EmptyState';

export interface ISessionEstimateListProps {
  estimate: Estimate;
}

export const SessionEstimateList = observer(() => {
  /** Context **/
  const estimateStore = useEstimateStore();

  /** State **/
  const [showAddModal, setShowAddModal] = useState(false);

  /** Computed **/
  const sessionEstimates = useMemo(() => {
    const items = estimateStore.currentEstimate?.session_estimates;
    return items && [...items].sort(byPosition);
  }, [estimateStore.currentEstimate?.session_estimates]);

  /** Methods **/
  const addSessionEstimate = async (title?: string, date?: DateString) => {
    await estimateStore.createSessionEstimate(title, date);
  };

  /** Render **/
  return (
    <Box gap="small" margin={{ horizontal: 'small', bottom: 'medium' }} pad="small">
      {estimateStore.canEditCurrent && (
        <Box alignSelf="end" pad={{ vertical: 'xsmall' }} margin={{ left: 'medium' }}>
          <AddNewButton secondary label="Add session estimate" onClick={() => setShowAddModal(true)} />
        </Box>
      )}
      <Box align="center">
        {sessionEstimates && !!sessionEstimates?.length ? (
          sessionEstimates.map((sessionEstimate) => (
            <SessionEstimatePanel key={sessionEstimate.id} sessionEstimate={sessionEstimate} />
          ))
        ) : (
          <EmptyState
            title="No session estimates yet"
            body="Add one for each session you want priced in this estimate."
            actionLabel={estimateStore.canEditCurrent ? 'Add session estimate' : undefined}
            onAction={() => setShowAddModal(true)}
          />
        )}
      </Box>
      {estimateStore.canEditCurrent && showAddModal && (
        <CreateSessionEstimateModal addSessionEstimate={addSessionEstimate} setShowModal={setShowAddModal} />
      )}
    </Box>
  );
});
